import { createFileRoute } from "@tanstack/react-router";
import { Heading } from "@panelgenie/shared-ui";

/**
 * Post-delete confirmation surface.
 *
 * `/settings/account` navigates here after a successful
 * `account.delete` mutation + Clerk sign-out. Fully anonymous (no
 * Clerk gate) so the post-sign-out browser still renders the
 * confirmation copy.
 *
 * Renders the SLA copy verbatim per `MVP.md` §4.10 step 2.
 */
export const Route = createFileRoute("/settings/account/deleted")({
  component: AccountDeletedPage,
});

function AccountDeletedPage() {
  return (
    <main
      aria-label="account-deleted-confirmation"
      className="mx-auto max-w-xl px-4 py-10 text-center"
    >
      <Heading level="h1" className="mb-6">
        Your account has been deleted
      </Heading>
      <p className="text-base text-fg">
        Deletion completes within 30 days; you&apos;ll receive a
        confirmation email when the process is finished.
      </p>
      <p className="mt-4 text-sm text-mute">
        Thanks for trying Panel Genie. You can close this tab.
      </p>
    </main>
  );
}
